import React from 'react'

import {
    Row,
    Col,
    Image
} from 'antd'

const MapaLotesMacrolotes = ({english}) => {
    const redireccionSelect = e => {
        window.location = english ? `/macro-lots/${e.target.value}` : `/macrolotes/${e.target.value}`
    }
    
    const beneficios = [
        'Servicios de Agua Potable, Energía Eléctrica, Internet y TV por cable a pie de lote.',
        'Acceso Náutico, terrestre y aéreo.',
        'Exuberante vegetación con cuidado meticuloso al medio ambiente.',
    ]
    
    const benefits = [
        'Drinking and irrigation water system, electricity, Internet and Cable TV services. Sea, land, and air access.',
        'Lush vegetation with meticulous care for the environment.',
    ]

    return (
        <Row align="middle" justify="center" style={{paddingTop: 15, paddingBottom: 25}}>
            <Col xs={24} md={12}>
                <Image width="100%" src="/ProyectosImagenes/Macrolotes/mapa/mapa-macrolotes.jpg" />
            </Col>
            <Col xs={24} md={12} className="contenedor-bloques">
                <Row>
                    <h2 className="titulo">{english ? 'Benefits' : 'Beneficios'}</h2>
                </Row>
                <Row>
                    <ul className="lista-beneficios">
                        {english ?
                                benefits.map((beneficio, index) => (
                                    <li 
                                        key={index}
                                        className="texto-proyecto"    
                                    >
                                        {beneficio}
                                    </li>
                                ))
                            :
                                beneficios.map((beneficio, index) => (
                                    <li 
                                        key={index}
                                        className="texto-proyecto"    
                                    >
                                        {beneficio}
                                    </li>
                                ))
                        }
                    </ul>
                </Row>
                <Row>
                    <h2 className="titulo">{english ? 'TECHNICAL SHEETS' : 'Fichas Técnicas'}</h2>
                </Row>
                <Row>
                    <p className="texto-proyecto">
                        {english 
                            ? 
                                'Select the macro lot for more information' 
                            : 
                                'Selecciona en el macrolote del que desees conocer más información'
                        }
                        
                    </p>
                </Row>
                <Row>
                    <select 
                        className="select-plano-maestro"
                        onChange={redireccionSelect}    
                    >
                        <option value="">{english ? 'Select the macro lot' : 'seleccionar ficha técnica de macrolote'}</option>
                        <option value="3">{english ? 'Lot' :'Macrolote'} 3</option>
                        <option value="6a">{english ? 'Lot' :'Macrolote'} 6a</option>
                        <option value="9">{english ? 'Lot' :'Macrolote'} 9</option>
                        <option value="11c2a">{english ? 'Lot' :'Macrolote'} 11c2a</option>
                        <option value="11c2b">{english ? 'Lot' :'Macrolote'} 11c2b</option>
                        <option value="11c1">{english ? 'Lot' :'Macrolote'} 11c1</option>
                        <option value="12a">{english ? 'Lot' :'Macrolote'} 12a</option>
                        <option value="12b">{english ? 'Lot' :'Macrolote'} 12b</option>
                        <option value="16a">{english ? 'Lot' :'Macrolote'} 16a</option>
                        <option value="22">{english ? 'Lot' :'Macrolote'} 22</option>
                        <option value="23d">{english ? 'Lot' :'Macrolote'} 23d</option>
                        <option value="26">{english ? 'Lot' :'Macrolote'} 26</option>
                    </select>
                </Row>
            </Col>
        </Row>
    )
}

export default MapaLotesMacrolotes